<template>
  <!--
      作者 gmshop
      时间：2019-10-26
      描述：设置-退货地址列表-修改
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--修改退货地址-->
      <div class="common-form">修改退货地址</div>
      <el-form-item label="收货人姓名 " prop="name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.phone" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="所在区域">
        <el-select v-model="form.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'  :rules="[{required: true,message: ' '}]"></el-option>
        </el-select>
        <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'  :rules="[{required: true,message: ' '}]"></el-option>
        </el-select>
        <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'  :rules="[{required: true,message: ' '}]"></el-option>
        </el-select>

      </el-form-item>
      <el-form-item label="详细地址" prop="detail" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.detail" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="form.sort" type="number" class="max-w460"></el-input>
        <div class="tips">数字越小越靠前</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit()" :loading="loading">提交</el-button>
      </div>


    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import DataApi from '@/api/data.js';

  export default {
    data() {
      return {
        loading: false,
        /*form表单数据*/
        form: {
          address_id: '',
          name: '',
          phone: '',
          sort: 1,
          province_id: '',
          city_id: '',
          region_id: '',
          detail: '',
        },
        areaList:[]

      };
    },
    created() {
      this.getArea();
      this.getData();
    },

    methods: {
      getArea(){
        let self = this;
        DataApi.getArea({}, true)
          .then(res => {
            self.areaList = res.data.regionData;
          })
          .catch(error => {

          });
      },
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },
      getData() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.$route.query.address_id
        SettingApi.addressDetail({
            address_id: params
          }, true)
          .then(data => {
            let detail = data.data.detail;
            // 将数据放在当前组件的数据内
            self.form.address_id = detail.address_id;
            self.form.name = detail.name;
            self.form.phone = detail.phone;
            self.form.province_id = detail.province_id;
            self.form.city_id = detail.city_id;
            self.form.region_id = detail.region_id;
            self.form.detail = detail.detail;
            self.form.sort = detail.sort;
          })
          .catch(error => {

          });

      },
      //提交表单
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.editAddress(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，修改成功',
                  type: 'success'
                });
                 self.$router.push('/setting/address/index');

              })
              .catch(error => {
                self.loading = false;
              });

          }
        });

      },

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/address/edit.vue